import type {
  FiatPrice,
  Product,
  TrackingProperties,
} from "@b2bportal/purchase-api";
import { axiosInstance } from "@hopper-b2b/api";

// TODO: This should be coming from an @b2bportal interface.
export interface Offer {
  discount: {
    Discount: "Percentage" | "FiatAmount";
    maxDiscount?: {
      fiat: FiatPrice;
      accountSpecific?: Record<string, unknown>;
      rewards?: Record<string, unknown>;
    };
    percentage?: number;
    amount?: {
      fiat: FiatPrice;
      accountSpecific?: Record<string, unknown>;
      rewards?: Record<string, unknown>;
    };
  };
  offerContent: {
    imageFolderUrl: string;
    imageUrl: string;
    lineItemDescription: string;
    termsAndConditions: string;
    title: string;
  };
  eligibleProducts: Product[];
  expiresOn: string;
  id: string;
  name: string;
  trackingPropertiesV2: TrackingProperties;
}

export interface OffersResponse {
  offers: Offer[];
}

export const getOffers = async (): Promise<OffersResponse> => {
  try {
    const path = "/api/v0/wallet/offers";
    const getOffersResponse = await axiosInstance.get(path);
    const offerData: OffersResponse = getOffersResponse.data;
    return offerData;
  } catch (e) {
    return null;
  }
};
